import Axios from 'axios';

import axiosInterceptors from './request-interceptors';

let APP_BUILD = 'poc';
const { host } = window.location;
console.log(` solidify ${host}`);
if (host === 'dev.genome.genpact.com' || host === 'genome-dev.genpact.com') APP_BUILD = 'dev';
else if (host === 'uat.genome.genpact.com' || host === 'genome-uat.genpact.com') APP_BUILD = 'uat';
else if (host === 'genome-eda-rel.azurewebsites.net' || host === 'genome.genpact.com') APP_BUILD = 'prod';
else if (host.includes('localhost')) APP_BUILD = 'local';

export const APP_ENV = APP_BUILD;
// let API_GATEWAY_ID = '30d9om5ra9';
let baseUrl = '';
// if (APP_BUILD === 'dev') {
//   API_GATEWAY_ID = 'ja3kjrvzk2';
// } else if (APP_BUILD === 'uat') {
//   API_GATEWAY_ID = '9i65yseef5';
// } else if (APP_BUILD === 'prod') {
//   API_GATEWAY_ID = 'o695vfezv9';
// }

if (APP_BUILD === 'local') {
  baseUrl = 'https://api-v2-dev.genpact.com/api/solidify';
} else if (APP_BUILD === 'prod') {
  // baseUrl = `https://0e07e0d1xk.execute-api.ap-south-1.amazonaws.com/api/solidify`; //`https://api.genpact.com/api/solidify`;
  baseUrl = `https://api-v2.genpact.com/api/solidify`;
} else {
  // baseUrl = `https://655s39d7e4.execute-api.ap-south-1.amazonaws.com/api/solidify`; //`https://genome-dev.genpact.com/api/solidify`; //`https://api-router.azurefd.net/poc/aws/api/genome/solidify`;
  baseUrl = `https://api-v2-dev.genpact.com/api/solidify`;
}
console.log(` solidify ${baseUrl}`);
Axios.defaults.baseURL = baseUrl;
Axios.defaults.headers.common['x-oauth-config-provider'] = 'genome-open-auth';
// Axios.defaults.headers.common.Accept = 'application/json';
axiosInterceptors({ $http: Axios });

export default Axios;
